$(function () {
  var $body = $('body');

  // only works on news listing page
  if (!$body.hasClass('page-type--newslisting')) return;

  var api = '/umbraco/api/searchapi/filternewsitems/';
  var newsListing, newsFilters;

  // list instance
  newsListing = new Vue({
    el: '.news-listing',
    data: newsItems, // from the initial load data
    methods: {
      getNewsDetail: function (news) {
        return news.Date + ' / ' + (news.DocumentTypeAlias === 'successStory' ? 'Success Story' : (news.Category[0] || ''))
      },

      prev: function () {
        this.fetch(newsFilters.selectedCategory, newsFilters.selectedDate, Math.max(1, this.pageNumber - 1));
      },

      next: function () {
        this.fetch(newsFilters.selectedCategory, newsFilters.selectedDate, Math.min(this.pageNumber + 1, this.totalPages));
      },

      reset: function () {
        newsFilters.fetchOnUpdate = false; // disable fetch-on-update for a moment
        newsFilters.selectedCategory = 'allzzzz';
        newsFilters.selectedDate = 'all';
        newsFilters.fetchOnUpdate = true;

        this.fetch(newsFilters.selectedCategory, newsFilters.selectedDate, 1);
      },

      fetch: function (category, date, page) {
        var vm = this;
        $.getJSON(api, {
          umbracoPageId: umbracoPageId, // from the initial load data
          page: page || 1,
          category: category,
          date: date
        }, function (data) {
          vm.pageSize = data.SearchResults.pageSize;
          vm.pageNumber = data.SearchResults.pageNumber;
          vm.totalItems = data.SearchResults.totalItems;
          vm.totalPages = data.SearchResults.totalPages;
          vm.items = data.SearchResults.items;

          newsFilters.dateCounters = data.DateCounts;
          newsFilters.$forceUpdate();
          newsFilters.updateDateList();
        })
      }
    }
  });

  // filter instance
  newsFilters = new Vue({
    el: '.filters--news-listing',
    data: {
      selectedCategory: 'all',
      selectedDate: 'all',
      expandedDateList: null,
      dateList: null,
      categoryList: null,
      fetchOnUpdate: true,
      dateCounters: null
    },
    mounted: function () {
      // Check if a category is set in the URL data
      var requestCategory = getParameterByName('category').toLowerCase();

      // build categoryList
      var $categoryListingItems = $(this.$refs['category-filter']).find('.filter__listing-item:not(.filter__listing-item--expandable)');
      this.categoryList = $categoryListingItems.map(function (idx, el) {
        var $el = $(el);

        // If this category matches the one requested in the URL data, set it as the selected category
        if(requestCategory != null && requestCategory != '' && requestCategory == $el.data('value').toLowerCase()) {
          this.selectedCategory = $el.data('value');
        }
        
        return {
          label: $el.find('.filter__listing-item-label').text().trim(),
          value: $el.data('value')
        }
      }.bind(this)).toArray();

      // build dateList
      this.updateDateList();
    },
    computed: {
      selectedCategoryLabel: function () {
        if (this.selectedCategory === 'all')
          return 'All Category';

        if (this.selectedCategory === 'success stories')
          return 'Success Stories';

        return this.selectedCategory;
      },
      selectedDateLabel: function () {
        if (this.selectedDate === 'all')
          return 'All Dates';

        return this.selectedDate;

      },
    },
    watch: {
      selectedCategory: function (newCategory) {       
        if (this.fetchOnUpdate)
          newsListing.fetch(newCategory, this.selectedDate)
      },
      selectedDate: function (newDate) {
        if (this.fetchOnUpdate)
          newsListing.fetch(this.selectedCategory, newDate)
      }
    },
    methods: {
      updateDateList: function () {
        var $dateListingItems = $(this.$refs['dates-filter']).find('.filter__listing-item:not(.filter__listing-item--expandable)');
        this.dateList = $dateListingItems.map(function (idx, el) {
          var $el = $(el);
          return {
            label: $el.find('.filter__listing-item-label').text().trim(),
            value: $el.data('value')
          }
        }).toArray();
      },

      getFilterListingItem: function (evt) {
        if ($(evt.target).hasClass('filter__listing-item'))
          return $(evt.target);

        return $(evt.target).parents('.filter__listing-item');
      },

      selectDate: function (evt) {
        var $filterListingItem = this.getFilterListingItem(evt);
        this.selectedDate = $filterListingItem.data('value');
        this.toggleDropdown(evt, false);
      },

      selectCategory: function (evt) {
        var $filterListingItem = this.getFilterListingItem(evt);
        this.selectedCategory = $filterListingItem.data('value');
        this.toggleDropdown(evt, false);
      },

      toggleDropdown: function (evt, flag) {
        var $filter = $(evt.target).parents('.filter');
        $filter.toggleClass('open', flag);
      },

      expandDateList: function (year) {
        if (this.expandedDateList === year) {
          this.expandedDateList = null;

        } else {
          this.expandedDateList = year;
        }
      },

      getCounter: function(dateStr){
        if(this.dateCounters && this.dateCounters[dateStr] !== undefined)
          return dateStr + ' ('+this.dateCounters[dateStr]+')';
      }
    }
  });
});